/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
define([], () => {

	class VisOlapContentHelper {
		constructor(visualization) {
			this.visualization = visualization;
		}

		//Normally, this function returns the list of metadata columns in the visualization.
		//In some cases (such as Dnd, we might get a list passed to us.)
		_getMetadataColumnList(dataSource, mdColumnList=null) {
			if (mdColumnList) {
				return mdColumnList;
			}
			const visMdColumnList = this.visualization.getSlots().getDataItemList().map((di) => di.getMetadataColumn() );
			let filterMdColumnList = [];
			if (dataSource) {
				const localFilterList = this.visualization.getLocalFilters().getFilterList() || [];
				const filterColumnIdList = localFilterList.filter((filter) => filter.columnId ).map((filter) => filter.columnId);
				filterMdColumnList = filterColumnIdList.map((filterColumnId) => filterColumnId && dataSource.getMetadataColumn(filterColumnId));
			}

			return [...visMdColumnList, ...filterMdColumnList];
		}

		//Return true if this visualization/columnList DEFINITELY contains olap
		containsOlap(mdColumnList = null) {
			const dataSource = this.visualization.getDataSource();
			let containsOlap =  dataSource &&  dataSource.isOlapPackage();

			if (!containsOlap) {
				//Get the metadata columns from the visualization or the explicit list passed in.
				mdColumnList = this._getMetadataColumnList(dataSource, mdColumnList);
				containsOlap = mdColumnList.some((mdColumn) => {
					//isOlapColumn considers both olapColumns and named sets
					return mdColumn && mdColumn.isOlapColumn();
				});
			}
			return containsOlap;
		}

		//Return true if this visualization/columnList LIKELY contains olap (uses: badges and NLT in explore)
		//NOTE: Hopefully, we can deprecate this function if we can get better information from modelling.
		//		see https://jsw.ibm.com/browse/MOSER-3236
		likelyContainsOlap(mdColumnList = null) {
			let containsOlap = this.containsOlap(mdColumnList);
			if (!containsOlap) {
				const dataSource = this.visualization.getDataSource();
				if (dataSource && dataSource.getType()==='uploadedFile') {
					//We know its not an olap package if its an uploadedFile, no need to check further.
					return false;
				}

				mdColumnList = this._getMetadataColumnList(dataSource, mdColumnList);
				const visHasOnlyCalculations = mdColumnList.every((mdColumn) => {
					return mdColumn && mdColumn.getObjectType() === 'Calculation';
				});

				if (visHasOnlyCalculations) {
					//Edge case: If we have a columnList with only calculations in it
					//AND its a mixed package that has olap, we have to consider that the calculation might have olap terms.
					return this._checkDataSourceForOlap(dataSource);
				}
			}
			//It definitely contains OLAP if we hit this return.
			return containsOlap;
		}

		_checkDataSourceForOlap(dataSource) {
			if (dataSource) {
				//Check the dataSource and cache the result so we only do it once (unless the source changes)
				if (this._currentDataSourceId!==dataSource.getId() || this._currentDataSourceHasOlap===undefined) {
					this._currentDataSourceHasOlap = dataSource.getMetadataColumnList().some((mdc) => mdc.isOlapColumn());
				}
				this._currentDataSourceId = dataSource.getId();
			}
			return this._currentDataSourceHasOlap;
		}
	}
	return VisOlapContentHelper;
});